import { AtlassianAppsTileSectionInteractedEvent, AtlassianAppsTileSectionViewedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { SURFACE_ANALYTICS_PRODUCT_MAP } from '@atlassian/surface-analytics';
/**
 * @param recommendedAppList - The list of first party recommended apps
 * @returns The list of CCPIDs for first party apps for tracking in surface analytics
 * @note We filter out undefined values because some apps may not have a CCPID assigned to them
 */
const getRecommendedProductIdsForFirstParty = recommendedAppList => {
  return recommendedAppList.map(app => SURFACE_ANALYTICS_PRODUCT_MAP.products[app]).filter(Boolean);
};
export const useAtlassianAppsAnalytics = recommendedAppList => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const targetProductList = recommendedAppList.map(app => app.targetProduct);
  const recommendedProductIds = getRecommendedProductIdsForFirstParty(targetProductList);
  const handleAtlassianAppsViewedEvent = () => {
    fireAnalyticsEvent({
      eventType: AtlassianAppsTileSectionViewedEvent,
      actionSubjectId: 'atlassianAppsTileSection',
      attributes: {
        recommendedProductIds,
        recommendedProductKeys: targetProductList
      },
      tags: ['crossFlow']
    });
  };
  const handleAtlassianAppsInteractedEvent = (targetProduct, cardPosition) => {
    fireAnalyticsEvent({
      eventType: AtlassianAppsTileSectionInteractedEvent,
      actionSubjectId: 'atlassianAppTile',
      attributes: {
        source: 'atlassianAppsTileSection',
        recommendedProductIds,
        targetProductId: SURFACE_ANALYTICS_PRODUCT_MAP.products[targetProduct],
        cardPosition,
        recommendedProductKeys: targetProductList,
        productKey: targetProduct
      },
      tags: ['crossFlow']
    });
  };
  return {
    handleAtlassianAppsViewedEvent,
    handleAtlassianAppsInteractedEvent
  };
};